import { Button, DrawerBody, DrawerHeader, DrawerHeaderTitle, OverlayDrawer } from '@fluentui/react-components'
import { Dismiss24Regular } from '@fluentui/react-icons'

type OverlayDrawerComponentProps = {
  open: boolean
  setOpen: (open: boolean) => void
  // setOpen: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  content: React.ReactNode
  size?: 'small' | 'medium' | 'large' | 'extra-large' // Add 'extra-large' for wider drawers
  customWidth?: string // Allow a custom width to be passed
}

export const OverlayDrawerComponent = (props: OverlayDrawerComponentProps) => {
  const getDrawerWidth = (size: string | undefined): string => {
    switch (size) {
      case 'small':
        return '300px'
      case 'medium':
        return '500px'
      case 'large':
        return '800px'
      case 'extra-large':
        return '1000px'
      default:
        return props.customWidth || '500px' // Use customWidth if provided, otherwise default to medium
    }
  }

  return (
    <OverlayDrawer
      as="aside"
      open={props.open}
      position="end"
      onOpenChange={(_, { open }) => props.setOpen(open)}
      size="large" // Keep size consistent for internal behavior
      style={{ width: props.customWidth || getDrawerWidth(props.size) }} // Use either `customWidth` or mapped width
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={() => props.setOpen(false)}
            />
          }
        >
          {props.title}
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody>{props.content}</DrawerBody>
    </OverlayDrawer>
  )
}
